<template>
    <b-navbar
        id="app-sidebar"
        v-if="$screen.width >= 768"
        toggleable="lg"
        class="d-none d-md-block navbar-vertical desk32-navbar-vertical-icon-md navbar-expand-md fixed-left navbar-light"
    >
        <div class="container-fluid">
            <b-navbar-brand class="p-0">
                <router-link class="nav-link pointer company-logo-sidebar" :to="{name:'home'}">
                    <img v-if="logo" :src="logo" class="navbar-brand-img mx-auto" alt="..." />
                    <img v-else src="@/assets/img/logo.svg" class="navbar-brand-img mx-auto" alt="..." />
                </router-link>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <hr class="dropdown-divider" />

            <b-collapse id="nav-collapse" is-nav>
                <navbar :items="menuItems"></navbar>
            </b-collapse>
        </div>
    </b-navbar>
    <b-navbar
        v-else
        id="mobile-bottom-navbar"
        class="mobile-bottom-navbar active navbar-vertical navbar-expand-md fixed-bottom navbar-light desk32-navbar-bottom-icon-text p-0"
        :class="{ 'pb-4': isDisplayStandaloneMode }"
    >
        <ul class="navbar-nav">
            <li class="nav-item" v-for="(item, index) in mobileMenuItems" :key="index">
                <router-link
                    class="nav-link pointer"
                    :exact-active-class="'active'"
                    :active-class="'active'"
                    :to="{name:item.route ? item.route : '', params:item.params}"
                >
                    <i class="d-flex justify-content-center fe" v-if="item.icon" :title="$t(item.label)" :class="item.icon"></i>
                </router-link>
            </li>
            <li class="nav-item w-auto">
                <a href="" class="nav-link pointer text-muted" @click.prevent="openModal({id:'mobileMenuModal'})">
                    <i class="fe fe-more-horizontal"></i>
                </a>
            </li>
        </ul>
        <mobile-menu-modal id="mobileMenuModal" :title="$t('Menu')">
            <navbar :items="menuItems"></navbar>
        </mobile-menu-modal>
    </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Navbar from "@/components/Navbar.vue";
import { modalMixins } from '@/mixins/modal.js'
import MobileMenuModal from "@/components/Navigation/MobileMenuModal.vue";

export default {
    components: {
        Navbar,
        MobileMenuModal
    },
    mixins: [modalMixins],
    data() {
        return {
            tasksCount: 0,
            isDisplayStandaloneMode: false,
        };
    },
    mounted() {
        const mqStandAlone = '(display-mode: standalone)'
        this.isDisplayStandaloneMode = (navigator.standalone || window.matchMedia(mqStandAlone).matches)
    },
    created() {
        this.fetchTasks({
            query: {
                $limit: 1,
                status: { $in: ['new'] },
                startDate: { $lte: this.$moment().endOf('day') }
            }
        }).then(data => {
            this.tasksCount = data.total
        });

        this.fetchAppointments({
            query: {
                $limit: 1,
                draft: true,
            }
        });

        window.addEventListener('resize', this.getScreenWidth);
        this.getScreenWidth();
    },
    destroyed() {
        window.removeEventListener('resize', this.getScreenWidth);
    },
    methods: {
        ...mapActions('tasks', { fetchTasks: 'find' }),
        ...mapActions('appointment', { fetchAppointments: 'find' }),

        getScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
    },
    computed: {
        ...mapGetters('my-company', {
            getMyCompany: 'get'
        }),
        ...mapGetters('appointment', {
            findAppointments: 'find'
        }),

        draftAppointments() {
            return this.findAppointments({
                query: {
                    draft: true,
                }
            }).total
        },

        logo() {
            if (!this.company.avatar) return null;
            return this.company.avatar.preview;
        },
        company() {
            return this.getMyCompany('mine');
        },
        fields() {
            return this.company.fields;
        },

        menuItems() {
            return [
                // {
                //     label: 'Dashboards',
                //     icon: 'fe-home',
                //     children: [
                //         { label: 'Default' },
                //         { label: 'Alternative' },
                //     ]
                // },
                {
                    label: 'Appointments',
                    icon: 'fe-calendar',
                    route: 'appointments',
                    resource: 'appointment',
                    actions: ['create'],
                    count: this.draftAppointments,
                    isInMobileNav: true
                    // children: [
                    //     // { label: 'Board', route: 'appointments.board', resource: 'appointment' },
                    //     {
                    //         label: 'List',
                    //         route: 'appointments.filter',
                    //         params: { filter: 'today' },
                    //         resource: 'appointment',
                    //         actions: ['create']
                    //     },
                    //     { label: 'Calendar', route: 'appointments.calendar', resource: 'appointment' },
                    // ]
                },
                {
                    label: 'Board',
                    icon: 'fe-grid',
                    route: 'board',
                    resource: 'appointment',
                    actions: ['create'],

                },
                {
                    label: 'Patients',
                    icon: 'fe-user',
                    route: 'people.customers',
                    resource: 'customers',
                    actions: ['create'],
                    isInMobileNav: true
                    // children: [
                    //     {
                    //         label: 'Debtors',
                    //         route: 'people.customers.filter',
                    //         params: { filter: 'debtors' },
                    //         resource: 'customers'
                    //     },
                    //     {
                    //         label: 'Upcoming',
                    //         route: 'people.customers.filter',
                    //         params: { filter: 'upcoming' },
                    //         resource: 'customers'
                    //     },
                    //     {
                    //         label: 'Outdated',
                    //         route: 'people.customers.filter',
                    //         params: { filter: 'outdated' },
                    //         resource: 'customers'
                    //     },
                    // ]

                },
                {
                    label: 'Store',
                    icon: 'fe-package',
                    route: 'materials',
                    resource: 'products',
                    actions: ['create']
                    // children: [
                    //     { label: 'Products', route: 'inventory' },
                    //     { label: 'Categories', route: 'inventory.categories' },
                    //     { label: 'Brands', route: 'inventory.brands' },
                    //     { label: 'Suppliers', route: 'inventory.suppliers' },
                    // ]
                },
                // {
                //     label: 'Company',
                //     icon: 'fe-briefcase',
                //     route: 'company',
                //     children: [
                //         { label: 'Services', route: 'company.services' },
                //         { label: 'Profile', route: 'company' },
                //         { label: 'Team', route: 'people.team' },

                //     ]
                // },
                {
                    label: 'Reports',
                    icon: 'fe-pie-chart',
                    route: 'reports.summary',
                    skipChecks: true,
                    resource: ['service-reports', 'appointment-reports',
                        'customer-reports', 'sales-reports', 'product-reports'],
                    actions: ['view'],
                    isInMobileNav: true
                },
                {
                    label: 'Tasks',
                    icon: 'fe-check-circle',
                    route: 'company.tasks',
                    module: 'tasks',
                    resource: ['tasks'],
                    actions: ['create'],
                    count: this.tasksCount,
                    isInMobileNav: true
                },
                {
                    label: 'Labs',
                    icon: 'fe-tag',
                    route: 'company.labs',
                    module: 'labs',
                    actions: ['create']
                },
                // {
                //     label: 'Services & prices',
                //     icon: 'fe-briefcase',
                //     route: 'company.services',
                //     resource: 'service',
                //     actions: ['create']
                // },
                // {
                //     label: 'References',
                //     icon: 'fe-box',
                //     route: 'company.icd',
                //     children: [
                //         { label: 'ICD-10', route: 'company.icd' },
                //         { label: 'Complaints', route: 'company.cdb' },
                //         { label: 'Objectively', route: 'company.odb' },
                //     ]
                // },

            ]
        },

        mobileMenuItems() {
            const menu = this.menuItems.filter(item => item.isInMobileNav)
            return menu.filter(item => {
                if (item.skipChecks) return item
                if (item.module) return this.$loadModule(item.module)
                if (this.$hasPermission(item.resource, item.actions || ['view'])) return item
            })
        },
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
    .dropdown-divider {
        display: none!important;
    }
    .mobile-bottom-navbar.active {
        transform: translateX(0);
    }
    .mobile-bottom-navbar {
        transition: .3s ease-in-out all;
        transform: translateY(50px);
    }
}
</style>
